import { useEffect } from 'react';

export function useClickOutside(ref, handler, enabled = true) {
    useEffect(() => {
        if (!enabled) {
            return undefined;
        }

        const node = ref.current;

        if (!node) {
            return undefined;
        }

        const ownerDocument = node.ownerDocument;

        const handleClickOutside = (event) => {
            if (!ref.current?.contains(event.target)) {
                handler();
            }
        };

        ownerDocument.addEventListener('mousedown', handleClickOutside);

        return () => ownerDocument.removeEventListener('mousedown', handleClickOutside);
    }, [ref, handler, enabled]);
}
